// extracted by mini-css-extract-plugin
module.exports = {"headerText":"UserList_headerText__3YyJ_","userListContainer":"UserList_userListContainer__3HHNk"};